var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { PeekCalendar, PeekInput, PeekStack, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import { Info } from "@piiqtechnologies/svg-icons";
import { format } from "date-fns";
export const CalendarDateSelector = (_a) => {
    var { disablePast = true, isAbsolute = true, top = 80, left = 50, field, form, disclaimerText } = _a, props = __rest(_a, ["disablePast", "isAbsolute", "top", "left", "field", "form", "disclaimerText"]);
    const theme = useTheme();
    const [showCalender, setShowCalender] = useState(false);
    const toggleShowCalender = () => {
        setShowCalender((showCalendar) => !showCalendar);
    };
    const onAddAvailableDate = (values) => {
        format(new Date(values), "MM/dd/yy");
        //@ts-ignore
        form.setFieldValue("datePeriod", undefined);
        //@ts-ignore
        form.setFieldValue(field.name, format(new Date(values), "MM/dd/yy"));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekCalendar, { disablePast: disablePast, onClose: toggleShowCalender, onChange: onAddAvailableDate, open: showCalender, allowSameDateSelection: true, renderInput: () => React.createElement(PeekInput, Object.assign({ onClick: toggleShowCalender, fullWidth: true, field: field, form: form }, props)), PopperProps: {
                disablePortal: true,
                sx: {
                    position: isAbsolute && "absolute !important",
                    top: `calc(100% - ${isAbsolute ? theme.spacing(top) : `${top}%`}) !important`,
                    left: `calc(100% - ${isAbsolute ? theme.spacing(left) : `${left}%`}) !important`,
                    ".MuiDayPicker-weekDayLabel": { color: "text.primary" },
                    ".PrivatePickersSlideTransition-root": { minHeight: "200px" },
                    ".PrivatePickersYear-yearButton.Mui-disabled": { color: "text.disabled" },
                },
            } }),
        disclaimerText && (React.createElement(PeekStack, { direction: "row", alignItems: "flex-start", spacing: 0.5, sx: {
                mt: 0.5,
                cursor: "pointer",
            }, onClick: toggleShowCalender },
            React.createElement(Info, { width: 12, height: 12, style: {
                    color: theme.palette.grey[800] || "#1F2937",
                    marginTop: "2px",
                    flexShrink: 0,
                } }),
            React.createElement(PeekTypography, { variant: "body1", sx: {
                    lineHeight: 1.4,
                    color: theme.palette.grey[800] || "#1F2937",
                } }, disclaimerText)))));
};
export default CalendarDateSelector;
